import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { APIROUTES } from '../../constants';
import { BaseService } from '../base/base.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmpowerService {

  constructor(
    private baseService: BaseService
  ) { }

  getAllRoles() {
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.ROLES).pipe(catchError(this.errorHandler));
  }

  getRoles() {
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.FILTEREDROLES).pipe(catchError(this.errorHandler));
  }

  searchUsers(name: string) {
    return this.baseService.post(environment.baseUrl + APIROUTES.EMPOWERMENT.SEARCHUSER, {name}).pipe(catchError(this.errorHandler));
  }

  getRoleByPermission(permission: number) {
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.ROLEBYPERMISSION(permission)).pipe(catchError(this.errorHandler));
  }

  getPermissions() {
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.PERMISSIONS).pipe(catchError(this.errorHandler));
  }

  getPermissionByRole(role: number) {
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.PERMISSIONSBYROLE(role)).pipe(catchError(this.errorHandler));
  }

  giveUserRole(user_id: number, role: string) {
    return this.baseService.post(environment.baseUrl + APIROUTES.EMPOWERMENT.USERROLE, {user_id, role}).pipe(catchError(this.errorHandler));
  }

  revokeUserRole(user_id: number, role: string) {
    return this.baseService.deleteWithBody(environment.baseUrl + APIROUTES.EMPOWERMENT.REVOKEUSERROLE, {user_id, role}).pipe(catchError(this.errorHandler));
  }

  giveUserPermission(user_id: number, permissions: string|string[]) {
    return this.baseService.post(environment.baseUrl + APIROUTES.EMPOWERMENT.USERPERMISSION, {user_id, permissions}).pipe(catchError(this.errorHandler));
  }

  revokeUserPermission(user_id: number, permissions: string|string[]) {
    return this.baseService.deleteWithBody(environment.baseUrl + APIROUTES.EMPOWERMENT.USERPERMISSION, {user_id, permissions}).pipe(catchError(this.errorHandler));
  }

  listActivities(offset : number = 0, startDate : string = '', endDate : string = '', searchQuery : string = '') {
    let params = new HttpParams().set('offset', offset.toString());
    if (startDate) {
      params = params.set('startDate', startDate);
    }

    if (endDate) {
      params = params.set('endDate', endDate);
    }

    if (searchQuery) {
      params = params.set('searchQuery', searchQuery);
    }
    return this.baseService.get(environment.baseUrl + APIROUTES.EMPOWERMENT.ACTIVITIES, params).pipe(catchError(this.errorHandler));
  }

  //Method to handle error
  errorHandler(error:any) {
    return of(error);
  }
}
